import React from 'react';
import { Col, Row, Layout } from 'antd';
import { FacebookFilled, InstagramFilled, TwitterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Copyright from './Copyright';
import {
  APP_STORE_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  PLAY_STORE_URL,
  TWITTER_URL,
} from '../../shared/variables/constants';
import {
  ROUTE_ABOUT,
  ROUTE_BUSINESS_LEAGUES,
  ROUTE_CLUBS,
  ROUTE_COURTS,
  ROUTE_DOUBLES_LEAGUES,
  ROUTE_CONTACT,
  ROUTE_HELP,
  ROUTE_HOW_DO_I_JOIN,
  ROUTE_LEAGUES,
  ROUTE_MATCH_PLAYING_PROCESS,
  ROUTE_NEWS,
  ROUTE_PRICING,
  ROUTE_PRIVACY_POLICY,
  ROUTE_PRIZES,
  ROUTE_RULES,
  ROUTE_TOURNAMENTS,
  ROUTE_TENNIS_GUIDE,
} from '../../shared/variables/routes';
import Link from 'next/link';
import { useRemoteConfig } from '../../lib/hooks';

export default function Footer() {
  const rc = useRemoteConfig();
  const { t } = useTranslation();

  const FOOTER_MENU = [
    {
      title: t('footer.sectionTitle'),
      links: [
        { text: t('footer.links.leagues'), url: ROUTE_LEAGUES },
        { text: t('footer.links.doublesLeagues'), url: ROUTE_DOUBLES_LEAGUES },
        { text: t('footer.links.businessLeagues'), url: ROUTE_BUSINESS_LEAGUES },
        { text: t('footer.links.clubs'), url: ROUTE_CLUBS },
        { text: t('footer.links.courts'), url: ROUTE_COURTS },
        { text: t('footer.links.tournaments'), url: ROUTE_TOURNAMENTS },
        { text: t('footer.links.tennisGuide'), url: ROUTE_TENNIS_GUIDE },
        { text: t('footer.links.news'), url: ROUTE_NEWS },
        { text: t('footer.links.about'), url: ROUTE_ABOUT },
        { text: t('footer.links.rules'), url: ROUTE_RULES },
        { text: t('footer.links.pricing'), url: ROUTE_PRICING },
        { text: t('footer.links.contact'), url: ROUTE_CONTACT },
      ],
    },
    {
      title: t('footer.processGuide'),
      links: [
        { text: t('footer.links.howToJoin'), url: ROUTE_HOW_DO_I_JOIN },
        { text: t('footer.links.matchPlaying'), url: ROUTE_MATCH_PLAYING_PROCESS },
        { text: t('footer.links.prizes'), url: ROUTE_PRIZES },
        { text: t('footer.links.help'), url: ROUTE_HELP },
        { text: t('footer.links.privacy'), url: ROUTE_PRIVACY_POLICY },
      ],
    },
  ];

  return (
    <Layout.Footer>
      <div className="footer">
        <Row gutter={[24, 48]} className="mb-xxl">
          {FOOTER_MENU.map((item, index) => (
            <Col xs={12} sm={12} lg={6} className="footer-menu" key={`footer-menu-${index}`}>
              <h3>{item.title}</h3>
              {/* antd List, ul içine div bastığı için "list" erişilebilirlik denetiminden kalıyordu */}
              <ul className="footer-menu-list">
                {item.links.map((menuItem: Base.MenuItem) => (
                  <li className="footer-menu-item" key={menuItem.url}>
                    <Link href={menuItem.url}>
                      <a>{menuItem.text}</a>
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>
          ))}

          <Col xs={12} sm={12} lg={6} className="footer-menu">
            <h3>{t('footer.followUs')}</h3>
            <div className="footer-social">
              <a target="_blank" rel="noreferrer" aria-label="Facebook" href={FACEBOOK_URL} className="footer-social-icon">
                <FacebookFilled />
              </a>
              <a target="_blank" rel="noreferrer" aria-label="Twitter" href={TWITTER_URL} className="footer-social-icon">
                <TwitterOutlined />
              </a>
              <a target="_blank" rel="noreferrer" aria-label="Instagram" href={INSTAGRAM_URL} className="footer-social-icon">
                <InstagramFilled />
              </a>
            </div>
          </Col>

          {rc.get('footer_download_app_icons_enabled') && (
            <Col xs={12} sm={12} lg={6} className="footer-menu">
              <h3>{t('footer.downloadApp')}</h3>
              <div className="footer-store">
                <a target="_blank" href={PLAY_STORE_URL} rel="noreferrer">
                  <img src="/images/google-play.svg" alt="Tenis.io Google Play" width={203} height={66} loading="lazy" />
                </a>
                <a target="_blank" href={APP_STORE_URL} rel="noreferrer">
                  <img src="/images/app-store.svg" alt="Tenis.io App Store" width={203} height={60} loading="lazy" />
                </a>
              </div>
            </Col>
          )}
        </Row>
        <Copyright />
      </div>
    </Layout.Footer>
  );
}
